import * as Types from '../constants/Types';
import Page from './../models/Page';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isFetching: false,
    isFetched: false,
    pages: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        page: new Page(),
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.PAGE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.PAGE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                pages: action.pages,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.PAGE_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, pages: [] };
        case Types.PAGE_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.PAGE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: { page: action.page, }
            };
        case Types.PAGE_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.PAGE_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.PAGE_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.PAGE_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.PAGE_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.PAGE_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.PAGE_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.PAGE_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.PAGE_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.PAGE_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.PAGE_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default:
            return state;
    }
}
